import { render } from "./ServicesYearFree.vue?vue&type=template&id=4fbac2ca"
import script from "./ServicesYearFree.vue?vue&type=script&lang=js"
export * from "./ServicesYearFree.vue?vue&type=script&lang=js"

import "./ServicesYearFree.vue?vue&type=style&index=0&id=4fbac2ca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__